import React, { useState, useEffect } from 'react';
import { Container, Button } from 'react-bootstrap';
import '../Styles/GenericPage.css';
import axios from 'axios';
import {Map, Marker, GoogleApiWrapper} from 'google-maps-react';
import { Link } from 'react-router-dom';
import InfoWindowEx from "./Utilities/InfoWindowEx";

const mapStyle = {
    width: '100%',
    height: '100%',
    left: '0',
    top: '0',
    position: 'absolute'
}

const mapContainer = {
    width: '100%',
    paddingBottom: '41.6%',
    height: '100%',
    overflow: 'hidden',
    position: 'relative'
}

const wellInfo = [
    {
        name: 'Burley Well',
        lat: 42.578519,
        long: -113.705640
    },
    {
        name: 'Rupert Well',
        lat: 42.678519,
        long: -113.825640
    },
    {
        name: 'Water Well',
        lat: 42.378519,
        long: -113.925640
    }
]

function MapContainer(props){

    let [showingInfoWindow, setShowingInfoWindow] = useState(false);
    let [selectedPlace, setSelectedPlace] = useState({});
    let [activeMarker, setActiveMarker] = useState({});

    let onMarkerClick = (props, marker, e) => {
        setSelectedPlace(props);
        setActiveMarker(marker);
        setShowingInfoWindow(true);
    }

    let onMapClicked = (props) => {
        if (showingInfoWindow) {
            setShowingInfoWindow(false);
            setActiveMarker(null);
        }
    };

    let navigateToWellInfo = () => {
        // props.history.push("/WellInfo");
        props.history.push({
            pathname: '/WellInfo',
            appState: { detail: selectedPlace }
          })
    }

    return (
        <div>
            <Container style={{height: '45rem'}}>
                <div style={mapContainer}>
                    <Map google={props.google} style={mapStyle} zoom={9} onClick={onMapClicked}
                     initialCenter={{lat: 42.578519, lng: -113.705640}}>

                        {wellInfo.map((item) =>
                            <Marker
                            onClick={onMarkerClick}
                            name={item.name}
                            position={{lat: item.lat, lng: item.long}} />
                        )}

                        <InfoWindowEx
                        marker={activeMarker}
                        visible={showingInfoWindow}>
                            <div>
                                <div style={{fontSize: '1rem'}}>
                                    {selectedPlace.name}
                                </div>
                                <Button onClick={navigateToWellInfo} variant="outline-info" style={{marginTop: '5px', fontSize: '10px'}}>Show Water Levels</Button>
                                {/* <div style={{color: 'rgb(67, 12, 236)'}} onClick={navigateToWellInfo}>
                                    Show Water Levels
                                </div> */}
                            </div>
                        </InfoWindowEx>
                    </Map>
                </div>
            </Container>
        </div>
      );
}

export default GoogleApiWrapper({
    apiKey: ('AIzaSyA1Xlxu7lcp2pgNcN_bbaJLuf8VB3yQzNg')
  })(MapContainer)